import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { UIButton, UIParagraph } from 'app/components/ui';
import ClampLines from 'app/components/ClampLines';
import BasketDishPriceLine from 'app/components/BasketPriceLine';

import addedImg from './added.img.svg';

import './dish-card-upsell.scss';


const DishCardUpsell = (props) => {
    const {
        strongTitle = '',
        caption = '',
        captionEn = '',
        upsellDishObserver = null,
        onClick = null,

        previewMobileImage,
        title,
        titleEn,
        dishPrice,
        loading,
        locale,
        id,
        isDishInBasket,
    } = props;

    const dishRootRef = useRef();

    useEffect(() => {
        if (upsellDishObserver) {
            upsellDishObserver.observe(dishRootRef.current);
        }
    }, []);

    const dishTitle = locale === 'en' ? (titleEn || title) : title;
    const dishCaption = locale === 'en' ? (captionEn || caption) : caption;

    const buttonContainerClasses = cn({
        'upsell__item__button-container': true,
        'upsell__item__button-container--free': dishPrice === 0,
    });

    return (
        <div styleName="upsell__item__root" ref={dishRootRef} data-id={id}>
            <div styleName="upsell__item__left-side">
                <img
                    styleName="upsell__item__image"
                    src={previewMobileImage}
                    alt={title}
                />
            </div>

            <div styleName="upsell__item__right-side">
                <UIParagraph level="4.1" data-test-id="upsell-dish__title">
                    <span styleName="upsell__item__title">
                        {strongTitle && (
                            <span styleName="bold">
                                {strongTitle}
                            </span>
                        )}
                        {dishPrice === 0 ? (
                            <>
                                <span styleName="bold">{dishTitle}</span>
                                <br />
                                {dishCaption}
                            </>
                        ) : (
                            <ClampLines
                                text={`${dishTitle} ${dishCaption}`}
                                linesCount={2}
                                delay={200}
                            />
                        )}
                    </span>
                </UIParagraph>

                {onClick && (
                    <div styleName={buttonContainerClasses}>
                        <UIButton
                            onClick={() => { onClick(); console.log('>>') }}
                            loading={loading}
                            sizeType="small"
                            aria-label="Добавить в корзину"
                            data-test-id="upsell-dish__add-to-basket-button"
                            disabled={isDishInBasket}
                        >
                            {isDishInBasket
                                ? <img src={addedImg} />
                                : (
                                    dishPrice === 0
                                    ? 'Бесплатно :)'
                                    : <BasketDishPriceLine price={dishPrice} />
                                )}
                        </UIButton>
                    </div>
                )}
            </div>
        </div>
    );
};

DishCardUpsell.propTypes = {
    previewMobileImage: PropTypes.string.isRequired,
    strongTitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    titleEn: PropTypes.string.isRequired,
    dishPrice: PropTypes.number.isRequired,
    onClick: PropTypes.func,
    upsellDishObserver: PropTypes.shape({ observe: PropTypes.func }),
    loading: PropTypes.bool.isRequired,
    caption: PropTypes.string,
    captionEn: PropTypes.string,
    locale: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,

};

export default DishCardUpsell;
